import axios from 'axios';

import BaseCrud from './baseCrud';
const crud = new BaseCrud('student');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    tagAssociations(
        ctx,
        {
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get('/admin/students/tag-associations', {
            params
        });
    },

    resetAllStudentTagAssociations() {
        return axios.$post(
            '/admin/students/reset-all-student-tag-associations'
        );
    }
};
